import { Component } from "@kluntje/core";

/**
 * Custom Element to display GetYourGuide Widget
 */
class FRAGetYourGuide extends Component {
  afterComponentRender() {
    this.loadJS();
  }

  loadJS() {
    const script = document.createElement("script");
    script.async = true;
    script.defer = true;
    script.crossOrigin = "anonymous";
    script.setAttribute("data-gyg-partner-id", "O9BCLYW");
    script.text =
      '!function(t){"function"==typeof define&&define.amd?define(t):t()}((function(){"use strict";var t,e=[/wp-admin/,/wp-login/,/preview=/,/localhost/,/^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])$/,/file:\\/\\//,/content:\\/\\//,/getyourguide/,/gygdev\\.gygtest/,/translate\\.google(usercontent)?\\.com/];function n(t,e){var n=document.getElementsByTagName("head")[0],o=document.createElement("script");o.async=!0,o.src=t,e&&(o.onload=e),n.appendChild(o)}!function(t){t[t.NOT_LOADED=0]="NOT_LOADED",t.LOADING="loading",t.OK="ok"}(t||(t={})),function(){if(!window.gygPAStatus){if(window.gygPAStatus=t.LOADING,window._GYG=window._GYG||{},window._GYG.env="production",!0!==window._GYG.loadOnlyPA){"test"===window._GYG.env&&console.log("Loading widget script");var o="https://widget.getyourguide.com/pw/latest/client-loader/widget.js";document.querySelector(\'script[src="\'+o+\'"]\')||n(o)}var i=("production"===window._GYG.env?"https://widget.getyourguide.com/dist/":"../dist/")+"pa-main.1705309054798_7219f020f56f49520ca816eae31481b9f4eb4419.umd.production.min.js";d=document.URL,c=0,e.forEach((function(t){t.test(d)&&c++})),0===c&&n(i,(function(){window.gygPAStatus=t.OK}))}var d,c}()}));\n' +
      "//# sourceMappingURL=pa.umd.production.min.js.map";
    document.body.appendChild(script);
  }
}

customElements.define("fra-e-get-your-guide", FRAGetYourGuide);

export default FRAGetYourGuide;
